import {ProductSpecificRuleState} from "@/modules/product_specific_rule/types"
import { RootState } from "@/store/types";
import {ActionTree, Module} from "vuex";
import { 
  getProductSpecificRules, 
  saveProductSpecificRule, 
  saveProductSpecificRules, 
  deleteProductSpecificRule,
  getProductSpecificRule,
  getProductSpecificRuleByIds
} from "@/services/product_specific_rule";

const actions: ActionTree<ProductSpecificRuleState, RootState> = {
    async GET_PRODUCT_SPECIFIC_RULES(_, payload) {
      return await getProductSpecificRules(payload);
    },

    async GET_PRODUCT_SPECIFIC_RULE(_, id) {
      return await getProductSpecificRule(id);
    },

    async GET_PRODUCT_SPECIFIC_RULES_BY_IDS(_, payload) {
      return await getProductSpecificRuleByIds(payload)
    },

    async SAVE_PRODUCT_SPECIFIC_RULE(_, product_specific_rule){
      return await saveProductSpecificRule(product_specific_rule);
    },

    async SAVE_PRODUCT_SPECIFIC_RULES(_, product_specific_rules) {
      return await saveProductSpecificRules(product_specific_rules);
    },

    async DELETE_PRODUCT_SPECIFIC_RULE(_, id) {
      return await deleteProductSpecificRule(id);
    }
  }

  export const product_specific_rule: Module<ProductSpecificRuleState, RootState> = {
    actions,
  }
